module.exports = __webpack_public_path__ + "img/qritem3.17a00bfd.png";